import qs from 'qs';
import HTTP from '../script/service';
import Util from '../script/util';
import store from './store';
import { message, Modal } from 'antd';
import {
  _nim_dis_connect,
  _show_award_modal,
  _hide_award_modal,
  _nim_block_msg,
  _nim_sync_done,
  _nim_change_session,
  _nim_update_multi_status,
  _change_nim_chat,
  _dssp_send_click,
  _anly_seng_custom,
  _change_phone_modal,
  _show_medal_get,
  _sync_nim_connect,
  _clear_user_info,
  _show_browser_warn,
} from './Action';
import WEBROOM from './WebRoom';
import nimOrderCmd from './nimOrderCmd';

const SDK = window.SDK;
const WEBIM = (window,
function () {
  const that = {
    uid: null, //用户ID
    account: null, //nim账号
    token: null,
    appkey: null,
    nim: null, //实例化对象
    conn: null, //链接状态
    sessions: [], //会话列表
    unread: 0, //消息未读数量
    msgs: {}, //所有消息内容
    syncDone: false, //是否同步完成
    userInfo: null,
    me: {}, //我的个人资料
    users: {}, //所有用户资料
    blacklist: {}, //黑名单
    onlineStatus: {}, //用户订阅状态
    to: null, //当前对话对象
    events: {}, //事件列表
  };
  //事件配置
  that.onConfigFn = function (key, fn) {
    that.events[key] = fn;
  };
  // 删除事件
  that.onDeleteEvent = function (key) {
    delete that.events[key];
  }
  //开始链接
  that.openConn = function (userInfo, base) {
    that.userInfo = userInfo;
    that.friends = userInfo.friends;
    that.uid = userInfo.uid;
    that.isRisk = userInfo.isRisk;
    that.account = userInfo.imUsername;
    that.token = userInfo.impassword;
    that.appkey = base.rootConfig.NIMKey;
    that.base = base;
    that.nim = SDK.NIM.getInstance({
      db: false, //是否支持本地数据库
      debug: false, //是否调试
      syncSessionUnread: true, //同步会话未读数
      syncRelations: true, //是否同步黑名单和静音列表
      syncRoamingMsgs: true, //同步漫游消息
      reconnectionAttempts: 15, //最大重连次数10
      quickReconnect: true,
      appKey: that.appkey,
      account: that.account,
      token: that.token,
      //链接成功
      onconnect: onConnect,
      //重新连接
      onwillreconnect: onWillReconnect,
      //断开连接
      ondisconnect: onDisconnect,
      //异常监控
      onerror: onError,
      //多端登录状态变化
      onloginportschange: onloginportschange,
      //黑名单
      onblacklist: onBlacklist,
      //其它端加入黑名单/从黑名单移除
      onsyncmarkinblacklist: onsyncmarkinblacklist,
      //个人信息
      onmyinfo: onMyInfo,
      //同步修改个人信息
      onupdatemyinfo: onMyInfo,
      //最近会话
      onsessions: onUpdateSession,
      //会话更新
      onupdatesession: onUpdateSession,
      //消息
      onmsg: saveMsg,
      // 自定义消息
      oncustomsysmsg: onCustomSysMsg,
      //漫游消息
      onroamingmsgs: saveMsgs,
      //离线消息
      onofflinemsgs: saveMsgs,
      //监听订阅事件列表
      onpushevents: onPushEvents,
      //同步完成
      onsyncdone: onSyncDone,
      // 获取我的好友列表
      onfriends: onFriends,
      // 好友关系变化回调
      onsyncfriendaction: onSyncFriendAction,
    });
  };
  // 获取好友列表
  function onFriends(friends) {
    that.friends = that.nim.mergeFriends(that.friends, friends);
    that.friends = that.nim.cutFriends(that.friends, friends.invalid);
  }
  // 好友变化回调
  function onSyncFriendAction(obj) {
    if (!obj?.type) return;
    if (obj.type === 'deleteFriend') {
      const findIndex = that.friends.findIndex(
        (item) => item.account === obj.account
      );
      if (findIndex > -1) {
        that.friends.splice(findIndex, 1);

        forceUpdateChatList(obj.account);
      }
    } else if (obj.type === 'addFriend') {
      that.friends.push(obj.friend);
    } else if (obj.type === 'updateFriend') {
      const findIndex = that.friends.findIndex(
        (item) => item.account === obj.friend.account
      );
      if (findIndex > -1) {
        let serverex = null;
        if (obj.friend?.serverex && Util.isJSONStr(obj.friend.serverex)) {
          serverex = JSON.parse(obj.friend.serverex);
        }
        // 删除还有关系
        if (serverex?.deleteFriend) {
          that.friends.splice(findIndex, 1);

          forceUpdateChatList(obj.friend.account);
        } else {
          that.friends[findIndex] = obj.friend;
        }
      } else {
        that.friends.push(obj.friend);
      }
    }
  }
  //补一次直播间上报
  that.sendChatRoom = function () {};
  //链接成功
  function onConnect(con) {
    console.warn('==connect success im==', con);
    that.conn = con;
    _sync_nim_connect();
  }
  //即将重连
  function onWillReconnect(obj) {
    console.warn('==onWillReconnect im==', obj);
    _sync_nim_connect(obj);
  }
  //断开链接
  function onDisconnect(error) {
    console.error('onDisconnect：', error);
    const params = {
      isRisk: that.isRisk,
      appKey: that.appkey,
      account: that.account,
      token: that.token,
      conn: that.conn,
    };
    _sync_nim_connect();
    _anly_seng_custom(1604, { params, data: error });
    //数据还原
    that.conn = null;
    that.sessions = [];
    that.onlineStatus = {};
    that.blacklist = {};
    that.unread = 0;
    that.syncDone = false;
    _nim_dis_connect();
    if (error.code == 'kicked') {
      _clear_user_info();
      message.error('登录状态被踢出~', 10);
    } else if (error?.retryCount >= 15) {
      // 超过重连次数，重连失败
      Modal.confirm({
        title: '提示',
        icon: null,
        closable: true,
        content: '网络异常无法自动重新链接，请刷新或重启软件',
        className: 'daidai-confirm-style',
        cancelText: '取消',
        okText: '确定',
        centered: true,
        onOk: () => {
          window.location.reload(true);
        },
        onCancel: () => {
          window.location.reload(true);
        },
      });
    }
  }
  //异常监控
  function onError(error) {
    const params = {
      isRisk: that.isRisk,
      appKey: that.appkey,
      account: that.account,
      token: that.token,
      conn: that.conn,
    };
    console.warn('onError：', error);
    _anly_seng_custom(1601, { params, data: error });
  }
  //多端登录状态变化
  function onloginportschange(obj) {
    console.warn('onloginportschange：', obj);
  }
  //黑名单
  function onBlacklist(obj) {
    that.blacklist = {};
    obj.forEach((item) => {
      that.blacklist[item.account] = item;
    });
  }
  //其它端加入黑名单/从黑名单移除
  function onsyncmarkinblacklist({ account, isAdd, record }) {
    if (isAdd) {
      that.blacklist[account] = record;
    } else {
      delete that.blacklist[account];
    }
  }
  //个人资料更新
  function onMyInfo(data) {
    if (data) that.me = addUserInfo(data);
  }
  //会话更新
  function onUpdateSession(session) {
    that.sessions = that.nim
      .mergeSessions(that.sessions, session)
      .filter((s) => s.to);
    that.unread = 0;
    let deleteSessions = [];
    that.sessions.forEach((item, index) => {
      //最多保留50条历史会话
      if (index >= 50) {
        deleteSessions.push({ scene: item.scene, to: item.to });
      } else {
        that.unread += item.unread;
      }
    });
    if (deleteSessions.length > 0) {
      that.sessions = that.sessions.slice(0, 50);
      that.nim.deleteSessions({ sessions: deleteSessions });
    }
    if (that.syncDone) onRefreshData();
  }
  // 更新会话列表排序，需要置顶客服 todo 使用云信API需要后台开通此功能
  function updateSessionSort(sessions) {
    const topSession = []; // 需要置顶的消息队列
    const normalSession = []; // 无需置顶的消息队列
    if (sessions?.length) {
      sessions.forEach((session) => {
        const user = that.users[session.to];
        if (user) {
          if (user?.custom?.toBusinessVipLevel?.length) {
            topSession.push(session);
          } else {
            normalSession.push(session);
          }
        }
      });
      sessions = [...topSession, ...normalSession];
    }
    return sessions;
  }
  //离线消息|漫游消息 -多条
  function saveMsgs(msgs) {
    if (Array.isArray(msgs.msgs)) {
      msgs.msgs.forEach((item) => {
        if (item.text)
          item.text = item.text.replace(
            /<|iframe|alert|javascript|marquee|console|confirm/g,
            '*'
          );
        saveMsg(item, true);
      });
    } else {
      if (msgs.text)
        msgs.text = msgs.text.replace(
          /<|iframe|alert|javascript|marquee|console|confirm/g,
          '*'
        );
      saveMsg(msgs.msgs, true);
    }
  }
  //新消息 -单条
  function saveMsg(msg, history, idServer) {
    try {
      if (msg.scene !== 'p2p') return false;
      if (
        msg.custom &&
        msg.custom != '' &&
        msg.custom != '{}' &&
        typeof msg.custom == 'string'
      ) {
        msg.custom = JSON.parse(msg.custom);
      }
      if (!msg.custom) msg.custom = {};
      //新消息
      if (msg.flow === 'in' && !history) {
        //关注
        if (
          msg.custom.action == '40-1' ||
          msg.custom.action == '40-2' ||
          msg.custom.action == '40-3'
        ) {
          changeFloow(msg.custom);
        }
        //获得勋章
        else if (
          msg.custom.action === '50-1' &&
          msg.custom.isShow == 1 &&
          msg.custom.medalEntity
        ) {
          _show_medal_get(msg.custom.medalEntity);
        }
        //符合弹窗要求
        else if (msg.custom.isShow == 1 && msg.custom.prizeList) {
          _show_award_modal({
            ...msg.custom,
            text: msg.text,
          }).then(() => {
            setTimeout(_hide_award_modal, 5000);
          });
        } else {
          playAudio();
        }
      }
      //消息存储
      const user = 'p2p-' + (msg.from === that.account ? msg.to : msg.from);
      if (!that.msgs[user]) that.msgs[user] = [];
      //本地组装消息
      if (msg.flow === 'out' && (idServer || idServer == 0)) {
        that.msgs[user].forEach((msgR) => {
          if (msgR.idClient == msg.idClient) {
            msgR.idServer = idServer;
            msgR.text = msg.text;
          }
        });
      } else {
        msg = getMessageConfig(msg);
        that.msgs[user].push(msg);
      }
      //必须先完成同步
      if (that.syncDone) {
        onRefreshData(() => {
          //是否是订单类消息
          if (msg?.custom && nimOrderCmd[msg.custom.action]) {
            that.events['_NIM_ORDER_MESSAGE'] &&
              that.events['_NIM_ORDER_MESSAGE'](msg);
          }
          //是否是当前聊天对象
          if (that.to && that.to.id == user) {
            that.events['_SET_CURR_MESSAGE'] &&
              that.events['_SET_CURR_MESSAGE'](msg, idServer);
          }
        });
      }
    } catch (error) {
      console.error('nim-msg-error:', error);
      _anly_seng_custom(1602, { params: msg, data: error.message });
    }
  }
  //消息解析
  function getMessageConfig(msg) {
    if (msg.type !== 'text' || msg.customText) {
      return msg;
    }
    //解构
    if (msg?.custom && typeof msg.custom == 'object') {
      if (
        msg.custom.action === '100-2' &&
        typeof msg.custom.details === 'string'
      ) {
        msg.custom.details = JSON.parse(msg.custom.details);
      }
    }
    //排除黑名单检测
    if (
      msg?.custom &&
      (!msg.custom.sensitiveWord || msg.custom.sensitiveWord == '0')
    ) {
      return msg;
    }
    // 无需解构数据 - 分享数据
    else if (msg?.custom && msg.custom.shareInfo) {
      return msg;
    }
    //大神资料卡
    else if (
      (msg.text.indexOf('localhost') !== -1 ||
        msg.text.indexOf('http') !== -1) &&
      msg.text.indexOf('dsid=') !== -1
    ) {
      const { dsid, jnid, ehot } = qs.parse(
        msg.text.split('#')[0].split('?')[1]
      );
      msg.customText = {
        dsid: dsid,
        jnid: jnid,
        link: msg.text,
        ehot: ehot === 'true' ? true : false,
        action: '0-1',
      };
    }
    //直播间分享
    else if (
      (msg.text.indexOf('localhost') !== -1 ||
        msg.text.indexOf('http') !== -1) &&
      msg.text.indexOf('roomid=') !== -1
    ) {
      const ppm = qs.parse(msg.text.split('#')[0].split('?')[1]);
      msg.customText = {
        roomid: ppm.roomid,
        link: msg.text,
        action: '0-2',
      };
    }
    return msg;
  }
  //音频播放
  function playAudio() {
    if (!that.myAudio) {
      that.myAudio = document.createElement('audio');
      that.myAudio.style.display = 'none';
      that.myAudio.src = '/assets/audio/5611.mp3';
      that.myAudio.volume = '0.5';
      document.body.appendChild(that.myAudio);
    }
    that.myAudio && that.myAudio.play();
  }
  //添加订阅
  function addSubscribeEvents(accounts) {
    let new_account = [];
    accounts.forEach((acc) => {
      if (!that.onlineStatus[acc] || that.onlineStatus[acc] == '离线')
        new_account.push(acc);
    });
    if (new_account && new_account.length > 0) {
      that.nim.subscribeEvent({
        type: 1,
        sync: true,
        accounts: new_account,
        vaildTime: 86400,
        subscribeTime: 86400,
      });
    }
  }
  //取消订阅
  function unSubscribeEvents(accounts) {
    if (accounts && accounts.length > 0) {
      accounts.forEach((account) => {
        delete that.onlineStatus[account];
      });
      that.nim.unSubscribeEventsByAccounts({
        type: 1,
        accounts: accounts,
        done: () => {
          _nim_update_multi_status(that.onlineStatus);
        },
      });
    }
  }
  //监听订阅
  function onPushEvents(param) {
    if (param.msgEvents) {
      param.msgEvents.forEach((data) => {
        let state = updateMultiPortStatus(data);
        let member = that.users[data.account];
        if (member) {
          if (member.custom?.stateHide) state = '离线';
          that.onlineStatus[data.account] = state;
        } else {
          that.onlineStatus[data.account] = state;
        }
      });
      //订阅推送
      if (that.syncDone) {
        _nim_update_multi_status(that.onlineStatus);
      }
    }
  }
  //订阅解析
  function updateMultiPortStatus(data) {
    if (data && data.account) {
      return data.value == 1 ? data.clientType : '离线';
    }
    return '离线';
  }
  // 自定义系统通知
  function onCustomSysMsg(data) {
    if (data?.content && typeof data.content === 'string') {
      const msg = JSON.parse(data.content);
      if (msg?.action === '102-1' || msg?.action === '102-2') {
        if (msg?.riskV2) {
          const { riskAuthData } = store.getState();
          if (!riskAuthData) {
            store.dispatch({
              type: 'risk_auth_data',
              data: { riskAuthData: { ...msg?.riskV2, isTrigger: true } },
            });
          }
        }
      } else if (msg?.action === '106-3') {
        store.dispatch({
          type: 'change_is_star_amount_dot',
          data: { isStarAmountDot: true },
        });
      }
      // 活动模板我的星力值变化
      else if (msg?.action === 'LIVE_BASE_ROOM_USER_STAR_BALANCE_CHANGE') {
        if (WEBROOM.roomid === msg.roomId) {
          store.dispatch({
            type: 'change_room_star_program',
            data: { activeTemplateStarAmount: msg?.starAmount || 0 },
          });
        }
      }
    }
  }
  //同步完成
  function onSyncDone() {
    onRefreshData(() => {
      that.syncDone = true;
      //加载敏感词库
      that.nim.getClientAntispamLexicon();
    });
  }
  //刷新数据
  function onRefreshData(callback) {
    let userAccounts = [];
    let subAccounts = [];
    that.sessions.forEach((item) => {
      let account = item.id.replace('p2p-', '');
      if (!that.users[account]) userAccounts.push(account);
      if (!that.onlineStatus[account]) {
        subAccounts.push(account);
        that.onlineStatus[account] = '离线';
      }
    });
    that.getUsersInfo(userAccounts).then(() => {
      that.sessions = updateSessionSort(that.sessions);
      //数据推送
      _nim_sync_done({
        conn: that.conn,
        me: that.me,
        sessions: that.sessions,
        msgs: {}, //不在全局推送
        users: that.users,
        blacklist: that.blacklist,
        onlineStatus: that.onlineStatus,
        unread: that.unread,
        to: that.to,
      });
      callback && callback();
    });
  }
  //关注
  function changeFloow(param) {
    let user = that.users[Util.$analyToAccount(param.uid)];
    if (user) {
      HTTP._if_focused_each({
        uid: that.uid,
        otherUid: param.uid,
      }).then((res) => {
        if (res.code == 200) {
          user.fllow = res.data;
        } else {
          user.fllow = { meToOther: 0, otherIfDnd: 0, otherToMe: 0 };
        }
        that.events['_SET_CURR_USER'] && that.events['_SET_CURR_USER'](user);
      });
    }
  }
  //添加用户资料到全局
  function addUserInfo(data) {
    if (data.custom && typeof data.custom == 'string') {
      data.custom = JSON.parse(data.custom);
    } else if (!data.custom) {
      data.custom = {};
    }
    data.custom.fllow = { meToOther: 0, otherIfDnd: 0, otherToMe: 0 };
    that.users[data.account] = data;
    //补偿一次状态判断
    let state = that.onlineStatus[data.account];
    if (data.custom?.stateHide) state = '离线';
    that.onlineStatus[data.account] = state;
    return data;
  }
  //是否允许发送消息
  function isSendContent(account = null) {
    const { rootConfig } = store.getState();
    //强制必须绑定手机
    if (
      (!that.userInfo.bindPhone || that.userInfo.bindPhone == '') &&
      rootConfig.lang == 'zh_CN'
    ) {
      _change_nim_chat();
      _change_phone_modal(true);
      return false;
    }
    if (that.blacklist[account || that.to.account]) {
      message.warning('你已将对方加入黑名单');
      return false;
    }
    return true;
  }
  // 强制刷新聊天列表
  function forceUpdateChatList(account) {
    const find = that.sessions.find((n) => n.id === `p2p-${account}`);
    if (find) {
      // 强制刷新DOM，更新好友列表
      that.events['_FRIEND_SESSION_UPDATE'] &&
        that.events['_FRIEND_SESSION_UPDATE']();
    }
  }
  //获取用户资料
  that.getUserInfo = function (account) {
    return new Promise(function (resolve, reject) {
      if (!that.conn) {
        resolve();
      } else if (that.users[account]) {
        resolve(that.users[account]);
      } else if (account) {
        that.nim.getUser({
          account: account,
          done: function (error, data) {
            if (!error && data) {
              let user = addUserInfo(data);
              resolve(user);
            } else {
              _anly_seng_custom(1603, { params: { account }, data: error });
              reject(error);
            }
          },
        });
      } else {
        resolve();
      }
    });
  };
  //获取用户资料 - 批量
  that.getUsersInfo = function (accounts) {
    return new Promise(function (resolve, reject) {
      if (!that.conn || !accounts || accounts.length == 0) {
        resolve([]);
      } else {
        that.nim.getUsers({
          accounts: accounts,
          done: function (error, data) {
            if (!error && data) {
              let users = [];
              data.forEach((user) => {
                let friend = that.friends?.find(
                  (e) => e.account == user.account
                );
                if (friend) {
                  user.fllow = { otherRemarkName: friend.alias };
                }
                // 首次添加订阅
                addSubscribeEvents([user.account]);

                addUserInfo(user);
                users.push(user);
              });
              resolve(users);
            } else {
              _anly_seng_custom(1603, { params: { accounts }, data: error });
              reject(error);
            }
          },
        });
      }
    });
  };
  //获取登录设备
  that.getDeviceType = function (account) {
    let online = that.onlineStatus[Util.$analyToAccount(account)];
    if (online && online != '离线') {
      return online.toString().toLocaleUpperCase();
    }
    return null;
  };
  //删除session回话
  that.removeSession = function (obj) {
    if (!that.conn) return;
    that.sessions.splice(
      that.sessions.findIndex((session) => session.id === obj.id),
      1
    );
    //删除订阅
    unSubscribeEvents([obj.to]);
    //删除会话
    that.nim.deleteSession({
      scene: 'p2p',
      to: obj.to,
      done: () => {
        _nim_change_session(that.sessions);
      },
    });
  };
  //统一设置聊天对象
  that.setToUser = async function (obj) {
    if (!that.conn) return;
    if (!obj && that.sessions.length == 0) {
      message.warning('当前没有消息内容,和对话记录。');
      return;
    } else if (!obj && that.sessions.length > 0) {
      let item = that.sessions[0];
      obj = { id: item.id, scene: 'p2p', account: item.to };
    } else if (obj && obj.account == that.account) {
      message.warning('无法与自己聊天');
      return;
    }
    //存储
    that.to = obj;
    if (obj.account) await that.getUserInfo(obj.account);
    let p2pUser = that.users[obj.account];
    console.log('用户信息', p2pUser);
    if (p2pUser && p2pUser.custom) {
      //风控账号
      if (p2pUser.custom.isRisk) {
        let msgArray = [...(that.msgs[obj.id] || [])];
        let lastmsg = null;
        if (msgArray.length > 0) {
          lastmsg = { ...msgArray[msgArray.length - 1] };
        }
        if (!lastmsg || !lastmsg.custom || !lastmsg.custom.isRisk) {
          msgArray.push({
            custom: { isRisk: true },
            type: 'text',
            text: '对方账号有异常，极有可能已被盗号。与其发送资金往来可能存在风险、请注意核实身份，平台外汇款平台概不负责，谨防诈骗。',
          });
          that.msgs[obj.id] = [...msgArray];
        }
      }
    } else {
      message.error('未找到聊天用户资料，请稍后再试~');
      return;
    }
    if (obj) {
      let sessionItem = that.sessions.filter((item) => item.id == obj.id);
      if (sessionItem.length == 0) {
        that.sessions.push({
          id: obj.id,
          to: obj.account,
          scene: 'p2p',
          unread: 0,
          updateTime: +new Date(),
          lastMsg: null,
        });
        //添加一次订阅
        addSubscribeEvents([obj.account]);
      }
      _change_nim_chat({
        to: obj,
        sessions: that.sessions,
        users: that.users,
        jnid: obj.jnid || null,
      });
      //设置当前会话
      that.nim.setCurrSession(obj.id);
      let user = that.users[obj.account];
      if (user.custom && user.custom.sys) {
        user.fllow = { meToOther: 0, otherIfDnd: 0, otherToMe: 0 };
        //更新对话对象
        that.events['_SET_CURR_USER'] && that.events['_SET_CURR_USER'](user);
      } else {
        const resolut = await HTTP._if_focused_each({
          uid: that.uid,
          otherUid: Util.$analyToUid(user.account),
        });
        if (resolut.code == 200 && resolut.data) {
          user.fllow = resolut.data;
        } else {
          user.fllow = { meToOther: 0, otherIfDnd: 0, otherToMe: 0 };
        }
        //更新对话对象
        that.events['_SET_CURR_USER'] && that.events['_SET_CURR_USER'](user);
      }
    } else {
      _change_nim_chat({
        to: obj,
        sessions: that.sessions,
        users: that.users,
        jnid: obj.jnid || null,
      });
    }
    _dssp_send_click(75, {
      from: Util.$analyToUid(that.account),
      to: Util.$analyToUid(obj.account),
      origin: obj?.origin || 'other',
    });
  };
  //删除历史记录
  that.clearHistory = function (account, callback) {
    if (!that.conn) return;
    that.nim.clearServerHistoryMsgs({
      account: account,
      delRoam: true,
      done: function () {
        //本地清空
        that.msgs[`p2p-${account}`] = [];
        //必须先完成同步
        onRefreshData(() => {
          that.events['_SET_CURR_MESSAGES'] &&
            that.events['_SET_CURR_MESSAGES']();
          callback && callback();
        });
      },
    });
  };
  //清除聊天对象
  that.resetCurrChat = function () {
    if (!that.conn) return;
    that.to = null;
    that.nim.resetCurrSession();
  };
  //加入黑名单
  that.addBlank = function (user) {
    HTTP._post_set_black_and_mute({
      otherUid: Util.$analyToUid(user.account),
      relationType: 1,
      value: 1,
    })
      .then((res) => {
        if (res?.code === 200) {
          that.blacklist[user.account] = true;
          // 必须先完成同步
          if (that.syncDone) {
            onRefreshData();
          }
          message.success('你已将对方加入黑名单');
        } else {
          message.warning(res?.message || '操作失败，请稍后重试~');
        }
      })
      .catch((err) => {
        message.warning('操作失败，请稍后重试~');
      });
  };
  //移除黑名单
  that.removeBlank = function (account, callback) {
    HTTP._post_set_black_and_mute({
      otherUid: Util.$analyToUid(account),
      relationType: 1,
      value: 0,
    })
      .then((res) => {
        if (res?.code === 200) {
          that.blacklist[account] = false;
          //必须先完成同步
          if (that.syncDone) {
            onRefreshData();
          }
          callback && callback();
          message.success('你已将对方移除黑名单');
        } else {
          message.warning(res?.message || '操作失败，请稍后重试~');
        }
      })
      .catch((err) => {
        message.warning('操作失败，请稍后重试~');
      });
  };
  //发送自定义贴图消息
  that.sendCustomMsg = async function (content) {
    if (!isSendContent()) return;
    if (!that.conn) return;
    const { rootConfig, chatErrCode } = store.getState();

    //本地验证
    let myLevel = parseInt(that.userInfo.wealthLevel.split('_')[0]);
    content.privilegeLevel = myLevel;
    /* 大数据上报所需字段 */
    if (window?.century_setting?.os_type != null)
      content.os_type = window.century_setting.os_type;
    const uuid = await Util.getReportUuid();
    if (uuid) content.uuid = uuid;
    if (WEBROOM?.isInRoom && WEBROOM?.roomid) content.room_id = WEBROOM.roomid;
    /* 大数据上报所需字段 */

    const newMsg = that.nim.sendCustomMsg({
      scene: 'p2p',
      to: that.to.account,
      content: JSON.stringify(content),
      pushPayload: JSON.stringify({
        channel_id: '114659', // 小米  推送
        vivoField: { classification: 1, category: 'IM' }, // vivo 推送
        hwField: { importance: 'NORMAL', category: 'IM' }, // 华为 推送
        oppoField: { channel_id: 'channel_id_chat' }, // oppo 推送
      }),
      done: function (error, msg) {
        if (error) {
          if (error.code) {
            // 20005 20006 错误码需要插入信息流
            newMsg.custom.errCode = error.code;
            newMsg.custom.errMsg = rootConfig.errorCode[error.code];
          }
          saveMsg(newMsg, false, 0);
          if (error.code === 20005 || error.code === 20005) {
            // 无需 toast 提示
          } else if (error.code === 20016) {
            // 唤起实名认证弹窗
            that.events['OPEN_REAL_MODAL'] &&
              that.events['OPEN_REAL_MODAL'](
                null,
                true,
                2,
                '为提升您的账号安全等级，需进行账号人脸认证，确保账号是您本人操作，防止账号被非法盗用及违规使用。'
              );
          } else if (error.code === 20017) {
            // 唤起极验验证弹窗
            that.events['OPEN_CAPTCHA_VERIFIED'] &&
              that.events['OPEN_CAPTCHA_VERIFIED'](100);
          } else if (error.code === 20020) {
            // 唤起防沉迷验证弹窗
            that.events['OPEN_ADDICTION_VERIFIED'] &&
              that.events['OPEN_ADDICTION_VERIFIED']();
          } else if (error.code === 20021) {
            // 唤起重复人脸验证弹窗 - 走的是实名认证的弹窗
            that.events['OPEN_REAL_MODAL'] &&
              that.events['OPEN_REAL_MODAL'](
                null,
                true,
                2,
                '为提升您的账号安全等级，需进行账号人脸认证，确保账号是您本人操作，防止账号被非法盗用及违规使用。'
              );
          } else if (error.code === 20022) {
            that.events['OPEN_REAL_MODAL'] &&
              that.events['OPEN_REAL_MODAL'](
                null,
                true,
                2,
                '检测到您的账号可能存在安全风险，需进行账号人脸认证，确保账号是您本人操作，防止账号被非法盗用及违规使用。'
              );
          } else if (error.code == 'Error_Connection_Socket_State_not_Match') {
            message.error('网络不畅，消息发送失败');
          } else {
            let dictsErr = chatErrCode
              ? chatErrCode.find((e) => e.code == error.code)
              : null;
            if (dictsErr) {
              message.error(dictsErr.message);
            } else if (rootConfig.errorCode[error.code]) {
              that.getCustomMsg(error.code);
            } else {
              message.error('网络不畅，消息发送失败');
            }
          }
        } else {
          saveMsg(msg, false, msg.idClient);
        }
      },
    });
    saveMsg(newMsg);
  };
  //发送消息
  that.sendText = function (text, custom = null, account = null) {
    if (!that.conn) return;
    return new Promise(async (resolve, reject) => {
      try {
        if (!isSendContent(account)) {
          resolve();
          return;
        }
        const toAccount = account || that.to.account;
        const timestamp = Util.getNowTime();
        let myLevel = parseInt(that.userInfo.wealthLevel.split('_')[0]);
        const { rootConfig, chatErrCode } = store.getState();

        //本地验证
        let sensitiveWord = _nim_block_msg(text);
        let customContent = custom
          ? custom
          : sensitiveWord
            ? { sensitiveWord: 1, privilegeLevel: myLevel }
            : { privilegeLevel: myLevel };
        if (customContent) {
          // 错误码返回的自定义参数，避免重新发送时携带此自定义参数
          delete customContent.errCode;
          delete customContent.errMsg;
        }
        if (!customContent) {
          customContent = {};
        }
        /* 大数据上报所需字段 */
        if (window?.century_setting?.os_type != null)
          customContent.os_type = window.century_setting.os_type;
        const uuid = await Util.getReportUuid();
        if (uuid) customContent.uuid = uuid;
        if (WEBROOM?.isInRoom && WEBROOM?.conn && WEBROOM?.roomid)
          customContent.room_id = WEBROOM.roomid;
        /* 大数据上报所需字段 */

        customContent.to = toAccount;
        customContent.timestamp = timestamp;
        customContent.sign = Math.random();
        customContent.source = rootConfig.source;
        const instance = await Util.getAssemblyInstance();
        if (instance?.exports) {
          const { imChatEncryption } = instance.exports;
          customContent.code = imChatEncryption(
            JSON.stringify(customContent),
            process.env.CLIENT_ENV
          );
        }
        const newMsg = that.nim.sendText({
          scene: 'p2p',
          to: toAccount,
          text: text,
          custom: customContent,
          pushPayload: JSON.stringify({
            channel_id: '114659', // 小米 推送
            vivoField: { classification: 1, category: 'IM' }, // vivo 推送
            hwField: { importance: 'NORMAL', category: 'IM' }, // 华为推送
            oppoField: { channel_id: 'channel_id_chat' }, // oppo 推送
          }),
          done: function (error, msg) {
            if (error) {
              console.log('--------------msg------------', error);
              if (error.code) {
                // 20005 20006 错误码需要插入信息流
                newMsg.custom.errCode = error.code;
                newMsg.custom.errMsg = rootConfig.errorCode[error.code];
              }
              saveMsg(newMsg, false, 0);
              if (error.code === 20005 || error.code === 20006) {
                // 无需 toast 提示
              } else if (error.code === 20016) {
                // 唤起实名认证弹窗
                that.events['OPEN_REAL_MODAL'] &&
                  that.events['OPEN_REAL_MODAL'](
                    null,
                    true,
                    2,
                    '为提升您的账号安全等级，需进行账号人脸认证，确保账号是您本人操作，防止账号被非法盗用及违规使用。'
                  );
              } else if (error.code === 20017) {
                // 唤起极验验证弹窗
                that.events['OPEN_CAPTCHA_VERIFIED'] &&
                  that.events['OPEN_CAPTCHA_VERIFIED'](100);
              } else if (error.code === 20019) {
                // 缺失加密字段 弹出升级弹窗
                console.log('异常用户，缺失加密字段', error);
                _show_browser_warn(true);
              } else if (error.code === 20020) {
                // 唤起防沉迷验证弹窗
                that.events['OPEN_ADDICTION_VERIFIED'] &&
                  that.events['OPEN_ADDICTION_VERIFIED']();
              } else if (error.code === 20021) {
                // 唤起重复人脸验证弹窗 - 走的是实名认证的弹窗
                that.events['OPEN_REAL_MODAL'] &&
                  that.events['OPEN_REAL_MODAL'](
                    null,
                    true,
                    2,
                    '为提升您的账号安全等级，需进行账号人脸认证，确保账号是您本人操作，防止账号被非法盗用及违规使用。'
                  );
              } else if (error.code === 20022) {
                that.events['OPEN_REAL_MODAL'] &&
                  that.events['OPEN_REAL_MODAL'](
                    null,
                    true,
                    2,
                    '检测到您的账号可能存在安全风险，需进行账号人脸认证，确保账号是您本人操作，防止账号被非法盗用及违规使用。'
                  );
              } else if (error.code === 20024) {
                //防沉迷操作 certOperateType 传0
                let realAuthData = {
                  areaType: 1,
                  certOperateType: 0,
                  isMsg: true,
                };
                store.dispatch({
                  type: 'real_auth_data',
                  data: { realAuthData: { ...realAuthData, isTrigger: true } },
                });
              } else if (error.code === 20025) {
                //实名 (已完成防沉迷 )  仅提交照片即可 certOperateType=2
                let realAuthData = {
                  areaType: 1,
                  certOperateType: 2,
                  isMsg: true,
                };
                store.dispatch({
                  type: 'real_auth_data',
                  data: { realAuthData: { ...realAuthData, isTrigger: true } },
                });
              } else if (error.code === 20026) {
                //直接实名(未完成过防沉迷) 填写证件号+传照片 certOperateType=1
                let realAuthData = {
                  areaType: 1,
                  certOperateType: 1,
                  isMsg: true,
                };
                store.dispatch({
                  type: 'real_auth_data',
                  data: { realAuthData: { ...realAuthData, isTrigger: true } },
                });
              } else if (error.code === 20027) {
                //已实名 提交证件照即可 certOperateType=2
                let realAuthData = {
                  areaType: 1,
                  certOperateType: 2,
                  isMsg: true,
                };
                store.dispatch({
                  type: 'real_auth_data',
                  data: { realAuthData: { ...realAuthData, isTrigger: true } },
                });
              } else if (error.code === 20028) {
                //实名信息等待审核
                message.error('实名信息等待审核中，请耐心等待！');
              } else if (
                error.code == 'Error_Connection_Socket_State_not_Match'
              ) {
                message.error('网络不畅，消息发送失败');
              } else {
                let dictsErr = chatErrCode
                  ? chatErrCode.find((e) => e.code == error.code)
                  : null;
                if (dictsErr) {
                  message.error(dictsErr.message);
                } else if (rootConfig.errorCode[error.code]) {
                  that.getCustomMsg(error.code);
                } else {
                  message.error('网络不畅，消息发送失败');
                }
              }
            } else {
              saveMsg(msg, false, msg.idClient);
            }
            resolve();
          },
        });
        saveMsg(newMsg);
      } catch (error) {
        if (error?.code === 1) {
          // 升级浏览器弹窗
          _show_browser_warn(true);
        }
      }
    });
  };
  // 动态文案 toast
  that.getCustomMsg = function (code) {
    const { userChatLimit, userLevel } = that.base;
    const { rootConfig } = store.getState();
    let toastText = rootConfig.errorCode[code];
    if (toastText.indexOf('[{用户等级}]') > -1) {
      let leaveName = userLevel[userChatLimit];
      toastText = toastText.replace('[{用户等级}]', leaveName);
    }
    message.error(toastText);
  };
  /**
   * 消息重新发送
   * @param msg 消息体
   * @param type 1：普通消息 2：自定义贴图
   */
  that.sendAgainText = function (msg, type) {
    const user = `p2p-${msg.to}`;
    const msgList = that.msgs[user];
    const idClient = msg.idClient;
    const index = msgList.findIndex((n) => n.idClient === idClient);
    if (index > -1) {
      const item = msgList.splice(index, 1);
      const deleteMsg = item[0];
      that.msgs[user] = [...msgList];
      if (type === 1) {
        that.sendText(deleteMsg.text, deleteMsg.custom);
      } else if (type === 2) {
        const content = deleteMsg.content;
        that.sendCustomMsg(JSON.parse(content));
      }

      // 因为历史消息列表变更，所以需要同步历史消息
      onRefreshData(() => {
        that.events['_SET_CURR_MESSAGES'] &&
          that.events['_SET_CURR_MESSAGES']();
      });
    }
  };
  return that;
})();
export default WEBIM;
